<div class="file-upload margin-top-1rem" [class.complete]="file.status == 2"
  [class.top-rounded-margin]="file.status == 0">
  <div class="vl"></div>
  <div class="info">
    <span class="file-name" [textContent]="(file.name || file.fileName)"></span>
    <a *ngIf="canRemoveFile" title="Remove">
      <span class="remove" (click)="removeFile()">x</span>
    </a>
    <div class="file-progress-bar" [class.notstarted]="file.status == 0" [class.complete]="file.status == 2">
      <div class="file-current-progress"></div>
    </div>
    <span [class]="file.status == 2 ? 'file-percent complete': 'file-percent'" *ngIf="file.status != 2"></span>
    <p class="action-links" *ngIf="file && file.status == 2 && (postUploadPreview || postUploadDownload)">
      <span *ngIf="postUploadDownload" [class.processingFile]="downloadingDoc" (click)="downloadFile()"
        [textContent]="!downloadingDoc ? 'Download':''"></span>
      <span *ngIf="postUploadPreview" [class.processingFile]="fetchingDoc" (click)="previewDoc()"
        [textContent]="!fetchingDoc ? 'Preview':''"></span>
    </p>
  </div>
</div>
<div id="pdfViewModal" *ngIf="fileType && fileType == 'pdf'" class="modal preview-modals" materialize="modal"
  [materializeParams]="[{dismissible: true}]">
  <div class="close-section right-align">
    <i class="material-icons" (click)="closeModal('pdfViewModal')">close</i>
  </div>
  <div class="pdf-content" *ngIf="!passwordRequired || (passwordRequired && passwordValidated)">
    <pdf-viewer [src]="documentSrc" [page]="currentPage" [fit-to-page]="true" [render-text]="true" [show-all]="false"
      [stick-to-page]="true" style="display: block;" (error)="onError($event)"
      (after-load-complete)="pdfLoadingComplete($event)"></pdf-viewer>
  </div>
  <div class="password-getter" *ngIf="passwordRequired && !passwordValidated">
    <i class="large lock-blue material-icons">lock</i>
    <p class="passwordProtectedDocumentMessage">The document is password protected.</p>
    <div class="documentPasswordInputDivision">
      <input materialize (keyup)="validatePasswordInput()" (keyup.enter)="fetchDocumentPassword()"
        placeholder="Enter password" [(ngModel)]="docPassword" #documentPasswordInput
        class="documentPasswordInput validate" minlength="1" [type]="viewPassword ? 'text' : 'password'" required>
      <i class="small grayEye passwordViewer material-icons" [class.greenEye]="viewPassword"
        (click)="viewPassword = !viewPassword">remove_red_eye</i>
    </div>
    <p class="errorMessage" *ngIf="errorMessage" [textContent]="errorMessage"></p>
  </div>
  <div class="modal-footer" *ngIf="passwordRequired && !passwordValidated">
    <button type="button" [disabled]="passwordValidated" class="btn zest-btn documentPreviewModalButton"
      [textContent]="'Submit'" (click)="fetchDocumentPassword()"></button>
  </div>
</div>
<div id="imageViewModal" class="modal preview-modals" *ngIf="fileType && fileType != 'pdf'" materialize="modal"
  [materializeParams]="[{dismissible: true}]">
  <div class="close-section right-align">
    <i class="material-icons" (click)="closeModal('imageViewModal')">close</i>
  </div>
  <div class="image-content">
    <img [src]="documentSrc | safe" alt="">
  </div>

</div>